import React from 'react'
import numeral from 'numeral'
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'
import { CELLS, ROWS } from 'modules/core/constants'
import _ from 'lodash'

const AUX_TYPES = {
  [ROWS.RATIO]: CELLS.TYPES.FONT_WIDTH_RATIO,
  [ROWS.FINANCIAL]: CELLS.TYPES.FONT_WIDTH_FINANCIAL,
}

const Number = ({
  value,
  format = '0,0',
  showNegativeInRed = false,
  showPositiveSign = false,
  type = '',
  hasVarsOrRule = null,
}) => {
  const numberClassName = (value, showNegativeInRed, hasVarsOrRule) => {
    if (value < 0 && showNegativeInRed) return CELLS.TYPES.RED
    if (_.keys(AUX_TYPES).includes(type)) {
      return AUX_TYPES[type]
    }
    if (hasVarsOrRule && hasVarsOrRule.hasRule) return ROWS.TYPES.APPLIED_RULE_ROW
    if (hasVarsOrRule && hasVarsOrRule.hasVars) return ROWS.TYPES.APPLIED_VAR_ROW
    return ''
  }

  if (value !== null && value !== '-' && value !== undefined && !isNaN(value)) {
    if (format === '%') {
      const absoluteValue = Math.abs(value)
      const formattedValue = numeral(absoluteValue).format('0.00%')

      const finalValue =
        showPositiveSign && value > 0
          ? `+${formattedValue}`
          : value < 0
          ? `-${formattedValue}`
          : formattedValue

      return (
        <span className={numberClassName(value, showNegativeInRed)}>
          {/* {numeral(value).format('0.00%')} */}
          {finalValue}
        </span>
      )
    }
    return (
      <span className={numberClassName(value, showNegativeInRed, hasVarsOrRule)}>
        {numeral(value).format(format)}
      </span>
    )
  }
  if (value === undefined) return ''
  return value // note: revisar si esta bien para todas las tablas este cambio. antes tenia '-'
}

const VariationTable = ({ value, amount = null, format = '0,0' }) => {
  const variationClassName = (value) => {
    const normalizedValue = normalizeVariationValue(value)

    if (normalizedValue > 0) return CELLS.TYPES.GREEN
    if (normalizedValue < 0) return CELLS.TYPES.RED

    return ''
  }

  const renderVariationIcon = (value) => {
    const normalizedValue = normalizeVariationValue(value)

    if (normalizedValue > 0) return <CaretUpOutlined />
    if (normalizedValue < 0) return <CaretDownOutlined />

    return null
  }

  const normalizedValue = normalizeVariationValue(value)

  return (
    <div className={variationClassName(normalizedValue)}>
      <Number value={normalizedValue} format="%" showPositiveSign />
      {renderVariationIcon(normalizedValue)}
    </div>
  )
}

const VariationKPI = ({ value }) => {
  const variationClassNameKPI = (value) => {
    if (value <= 0) return CELLS.TYPES.RED
    if (value > 0 && value < 0.5) return CELLS.TYPES.YELLOW
    if (value >= 0.5) return CELLS.TYPES.GREEN_KPI
  }

  return (
    <div className={variationClassNameKPI(value)}>
      <Number value={value} format="%" />
    </div>
  )
}

const normalizeVariationValue = (value = 0) => {
  const normalized = parseFloat(value)

  // evita -0,00%
  if (Math.abs(normalized) < 0.000001) {
    return 0
  }

  return normalized
}

const Variation = ({ value, amount = null, format = '0,0' }) => {
  const normalizedValue = normalizeVariationValue(value)

  const isPositive = normalizedValue > 0
  const isNegative = normalizedValue < 0
  const isNeutral = normalizedValue === 0

  const variationClassName = () => {
    if (isPositive) return CELLS.TYPES.GREEN
    if (isNegative) return CELLS.TYPES.RED
    return ''
  }

  const renderVariationIcon = () => {
    if (isPositive) return <CaretUpOutlined />
    if (isNegative) return <CaretDownOutlined />
    return null
  }

  return (
    <div className={variationClassName()}>
      <Number value={normalizedValue} format="%" showPositiveSign />
      {!isNeutral && renderVariationIcon()}
    </div>
  )
}

const CellStyle = {
  Number,
  VariationTable,
  VariationKPI,
  Variation,
}

export default CellStyle
